import { Channel, mockChannels } from "pages/Support/Channels/mockChannels";

export const getChannels = (): Promise<Channel[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockChannels);
    }, 100);
  });
};

export const getChannelById = (id: number): Promise<Channel | undefined> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const channel = mockChannels.find((channel) => channel.id === id);
      resolve(channel ?? undefined);
    }, 100);
  });
};
